export default "__VITE_ASSET__BEUaUlrN__"